import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import { SAVE_TO_PARENT_KEY, UPDATE_CURRENT_PROPERTY_KEY } from '../../../../utils/postingUtils';

import TextAreaFormField from '../../FormFields/TextAreaFormField';

const propTypes = {};

const defaultProps = {};

const RoommateDescriptionFormField = () => {
  const {
    properties: {
      currentProperty: {
        roomForRent: {
          currentRoommatesDetails: { roommateDetailsDescription },
        },
      },
    },
  } = useSelector((state) => state);

  return (
    <TextAreaFormField
      dataTestId="RoommateDescriptionFormField"
      inputName="roommateDetailsDescription"
      label="Roommates description"
      placeholder="Example: Two working professionals who are dog-friendly, respectful, communicative, and clean."
      initialValue={roommateDetailsDescription}
      required={false}
      saveToParentKey={SAVE_TO_PARENT_KEY.ROOM_FOR_RENT}
      updateCurrentPropertyKey={UPDATE_CURRENT_PROPERTY_KEY.ROOM_FOR_RENT_CURRENT_ROOMMATES_DETAILS}
    />
  );
};

RoommateDescriptionFormField.propTypes = propTypes;
RoommateDescriptionFormField.defaultProps = defaultProps;

export default memo(RoommateDescriptionFormField);
